module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "part"
  }, [_vm._v("PART ONE ")]), _vm._v(" "), _c('h2', {
    staticClass: "parta"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Common sense is instinct, and enough of it is genius.")])]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—")]), _vm._v("H. W. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAW")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9ad30b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Part1.vue
// module id = 72
// module chunks = 0